import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

@Component({
    selector: 'app-gen-display-ad-desktop-08',
    imports: [CommonModule, DesktopFrameComponent],
    templateUrl: './display-ad-desktop-08.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/display/display-desktop-styles.scss',
        './display-ad-desktop-08.component.scss',
    ]
})
export class DisplayAdDesktop08PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /**
   * Row count for the skeleton article text beside the ad rail. The mock draws
   * four full lines and a short one, and only the count matters, so the array is
   * empty on purpose.
   */
  readonly bodyBars = Array.from({ length: 5 });

  /** The publisher site nav, drawn as inert pills. Count only, as above. */
  readonly navItems = Array.from({ length: 4 });
}
